var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleColors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12901",
    "data-name": "Group 12901",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.388,
    height: 12.388,
    viewBox: "0 0 12.388 12.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6194",
    "data-name": "Path 6194",
    d: "M6.194,0A6.194,6.194,0,1,1,0,6.194,6.194,6.194,0,0,1,6.194,0Z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_285",
    "data-name": "Ellipse 285",
    cx: 3.709,
    cy: 3.709,
    rx: 3.709,
    ry: 3.709,
    transform: "translate(2.484 2.485)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleColors);
export default __webpack_public_path__ + "static/media/icon-circle-colors.5c61135cc9af72749c6eae0af2e3609b.svg";
export { ForwardRef as ReactComponent };